export enum Salutation {
  UNKNOWN = 'UNKNOWN',
  MR = 'MR',
  MRS = 'MRS',
}
